import { render } from "./item-groups.vue?vue&type=template&id=130456e3&scoped=true"
import script from "./item-groups.vue?vue&type=script&lang=js"
export * from "./item-groups.vue?vue&type=script&lang=js"

import "./item-groups.vue?vue&type=style&index=0&id=130456e3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130456e3"]])

export default __exports__